module.exports = __webpack_public_path__ + "static/media/09A.e9ce9e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/09A.png
// module id = 257
// module chunks = 0